"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ImageUtil = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _ = require("./");

var ImageUtil = /*#__PURE__*/function () {
  function ImageUtil() {
    (0, _classCallCheck2.default)(this, ImageUtil);
  }

  (0, _createClass2.default)(ImageUtil, null, [{
    key: "getImage",
    value: function getImage(identifier, uri) {
      if (uri) {
        return new _.RemoteImage({
          uri: uri
        });
      }

      return undefined;
    }
  }, {
    key: "getBackgroundImage",
    value: function getBackgroundImage(identifier, uri) {
      var bgImage = ImageUtil.getImage(identifier, uri);

      if (bgImage) {
        return bgImage;
      }

      return _.defaultDreamImage;
    }
  }]);
  return ImageUtil;
}(); // public static getImage(identifier?: string, uri?: string): ImageSource | undefined {
//   if (identifier) {
//     const matchingBackgrounds = ImageUtil.dreamBackgrounds.filter((value, index , array) => {
//       return value?.externalIdentifier == identifier;
//     });
//
//     if (matchingBackgrounds.length > 0) {
//       return matchingBackgrounds[0];
//     }
//   } else if (uri) {
//     return new RemoteImage(uri);
//   }
//
//   return undefined;
// }
//
// public static getBackgroundImage(identifier?: string, uri?: string): ImageSource {
//   const bgImage = ImageUtil.getImage(identifier, uri);
//   if (bgImage) {
//     return bgImage;
//   }
//   else {
//     return defaultDreamImage;
//   }
// }


exports.ImageUtil = ImageUtil;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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